import { UMButton, UMStack, UMToolGroup, UMR } from '../../../urbanmap/_components';
import type { useNetwork } from './useNetwork';

export function NetworkControls({ network: n, blocked }: {
  network: ReturnType<typeof useNetwork>; blocked: boolean;
}) {
  const disabled = blocked || n.loading || !!n.activeTool;
  return <UMStack gap={12}>
    <UMToolGroup label="Canalisations" activeId={n.activeTool}
      tools={[
        { id: 'draw-pipe', icon: 'polyline', label: 'Tracer', disabled: disabled && n.activeTool !== 'draw-pipe' },
        { id: 'erase-pipe-lasso', icon: 'ink_eraser', label: 'Effacer',
          disabled: (disabled && n.activeTool !== 'erase-pipe-lasso') || !n.network.pipes.length },
      ]}
      onSelect={(id) => { if (id === 'draw-pipe' || id === 'erase-pipe-lasso') n.start(id); }} />
    <UMStack>
      <div style={{ fontSize: 14, fontWeight: 600 }}>Tracé automatique</div>
      <UMButton disabled={disabled || !!n.precondition} onClick={n.calculate}>
        <span style={{ whiteSpace: 'normal', maxWidth: 190 }}>
          Calculer le tracé optimal
        </span>
      </UMButton>
      <div role="status" aria-live="polite" style={{ fontSize: 12, color: UMR.textMuted }}>
        {n.traceLoading && <div>Calcul simulé en cours…</div>}
        {n.precondition && <div>{n.precondition}</div>}
        {n.message && <div>{n.message}</div>}
        {n.stale && <div role="alert" style={{ fontWeight: 700 }}>
          Raccordements obsolètes — les centrales, bâtiments ou canalisations ont changé.
          Les anciens liens simulés sont atténués et ne sont plus conformes.
          Relancez manuellement le calcul. Les canalisations manuelles sont conservées.
        </div>}
      </div>
      {n.traceLoading && <UMButton variant="secondary" onClick={n.cancel}>Annuler le calcul</UMButton>}
    </UMStack>
  </UMStack>;
}
